export const QUICKVIEW_STORAGE_KEY = "cs2-quickview-v1";

type QuickviewSelection = {
  mapId?: string;
  side?: "T" | "CT";
  tacticId?: string;
  player?: "P1" | "P2" | "P3" | "P4" | "P5";
};

/** Liest die zuletzt gespeicherte Map/Seite/Taktik/Spieler-Auswahl. */
export function readQuickviewSelection(): QuickviewSelection {
  try {
    return JSON.parse(
      localStorage.getItem(QUICKVIEW_STORAGE_KEY) ?? "{}",
    ) as QuickviewSelection;
  } catch {
    return {};
  }
}

/**
 * Schreibt Map/Seite/Taktik in den localStorage-Eintrag, den Quickview und
 * Editor beim Mount lesen — Übergabe zwischen den beiden Ansichten ohne
 * URL-Query-Parameter. Bestehende `player`-Auswahl bleibt erhalten.
 */
export function writeQuickviewSelection(selection: {
  mapId: string;
  side: "T" | "CT";
  tacticId: string;
}): void {
  localStorage.setItem(
    QUICKVIEW_STORAGE_KEY,
    JSON.stringify({ ...readQuickviewSelection(), ...selection }),
  );
}
